export default __webpack_public_path__ + "61e541c.png";